import Axios from "./index";

export const requestAuthUrl = () => {
  return Axios.get("/user/twitter/request_url");
};

export const connectTwitterAccount = (params) => {
  return Axios.post("/user/twitter", params);
};

export const disconnectTwitterAccount = () => {
  return Axios.delete("/user/twitter");
};
